module.exports = __webpack_public_path__ + "img/img_index_cha_01_2@2x.b20bc25a.png";